import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderStatusCard = ({ title, value, change, changeType, icon, color = 'primary' }) => {
  const getColorClasses = (colorType) => {
    const colors = {
      primary: 'bg-primary/10 text-primary border-primary/20',
      success: 'bg-emerald-50 text-emerald-600 border-emerald-200',
      warning: 'bg-amber-50 text-amber-600 border-amber-200',
      error: 'bg-red-50 text-red-600 border-red-200'
    };
    return colors?.[colorType] || colors?.primary;
  };

  const getChangeColor = (type) => {
    return type === 'positive' ? 'text-emerald-600' : type === 'negative' ? 'text-red-600' : 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 transition-hover hover:elevation-1">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${getColorClasses(color)}`}>
          <Icon name={icon} size={24} />
        </div>
        {change && (
          <div className={`flex items-center space-x-1 ${getChangeColor(changeType)}`}>
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
              size={16} 
            />
            <span className="text-sm font-medium">{change}</span>
          </div>
        )}
      </div>
      <div>
        <h3 className="text-2xl font-semibold text-foreground mb-1">{value}</h3>
        <p className="text-sm text-muted-foreground">{title}</p>
      </div>
    </div>
  );
};

export default OrderStatusCard;